import { Button, Modal, ModalBody, ModalContent, ModalFooter, ModalHeader, ModalOverlay, Text } from "@chakra-ui/react";

// TODO: styling

export function ErrorModal({ isOpen, onClose }) {
  return (
    <Modal isOpen={isOpen} size="xl" isCentered>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Something's wrong</ModalHeader>
        <ModalBody>
          <Text>Uh... oh...</Text>
          <Text>Unexpected error BTFDCA'ing! 😭</Text>
        </ModalBody>
        <ModalFooter>
          <Text>Who you gonna call?</Text>
          <Button onClick={onClose} ml="1em" colorScheme="teal" size="sm">
            Close this
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}
